import {computed, observable} from 'mobx';
import TimelineEntry from 'main/stores/performance_goals/timeline_entries/TimelineEntry';
import {FormattedMessage} from 'react-intl';
import {fullName} from 'shared/tools';

class GoalComment extends TimelineEntry {
  @observable text;

  @computed get actionDescription() {
    return (
      <div>
        <span className='h3 medium'>
          {fullName(this.user)}
        </span>
        &nbsp;
        <span className='jumbo'>
          <FormattedMessage id='goals.left a comment'/>
        </span>
      </div>
    );
  }
}

export default GoalComment;
